import ActionTypes from '../actions/types'
import { createReducer } from 'reduxsauce'
import Utils from '../utils/Utils'

const INITIAL_STATE = {
  connections: []
}

const addConnection = (state, action) => {
  const { id, name, mobileNumber, countryCode } = action.payload
  let connectionIndex = Utils.getIndexOfObjectWithId(state.connections, id)
  let connection = {
    id,
    name,
    mobileNumber,
    countryCode
  }
  let newConnections

  if (connectionIndex === -1) {
    newConnections = [...state.connections, connection]
  } else {
    const existingConnection = state.connections[connectionIndex]
    newConnections = state.connections.map((c, index) =>
      index === connectionIndex ? { ...existingConnection, ...connection } : c
    )
  }

  return {
    ...state,
    connections: newConnections
  }
}

const addConnections = (state, action) => {
  const connections = action.payload.connections

  // Build index map for O(1) lookups
  const existingConnectionsMap = new Map(
    state.connections.map((connection, index) => [connection.id, index])
  )

  // Merge connections
  const updatedConnections = [...state.connections]
  const newConnectionsToAdd = []

  connections.forEach(connectionToAdd => {
    const { id, name, mobileNumber, countryCode } = connectionToAdd
    const connection = {
      id,
      name,
      mobileNumber,
      countryCode
    }

    const existingIndex = existingConnectionsMap.get(id)
    if (existingIndex !== undefined) {
      // Update existing connection
      updatedConnections[existingIndex] = {
        ...updatedConnections[existingIndex],
        ...connection
      }
    } else {
      // Queue new connection for addition
      newConnectionsToAdd.push(connection)
    }
  })

  return {
    ...state,
    connections: [...updatedConnections, ...newConnectionsToAdd]
  }
}

const setConnectionAvatarImages = (state, action) => {
  let { id, images } = action.payload
  let index = Utils.getIndexOfObjectWithId(state.connections, id)

  if (index !== -1) {
    const connection = state.connections[index]
    const newConnections = state.connections.map((c, i) =>
      i === index ? { ...connection, images: images } : c
    )
    return {
      ...state,
      connections: newConnections
    }
  }

  return state
}

const deleteConnectionAvatarImages = (state, action) => {
  let { id } = action.payload
  let images = {}
  let index = Utils.getIndexOfObjectWithId(state.connections, id)

  if (index !== -1) {
    const connection = state.connections[index]
    const newConnections = state.connections.map((c, i) =>
      i === index ? { ...connection, images: images } : c
    )
    return {
      ...state,
      connections: newConnections
    }
  }

  return state
}

const ACTION_HANDLERS = {
  [ActionTypes.ADD_CONNECTION]: addConnection,
  [ActionTypes.ADD_CONNECTIONS]: addConnections,
  [ActionTypes.SET_CONNECTION_AVATAR_IMAGES]: setConnectionAvatarImages,
  [ActionTypes.DELETE_CONNECTION_AVATAR_IMAGES]: deleteConnectionAvatarImages
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
